(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-program-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.cpReady) return;
      root.dataset.cpReady = '1';
      const form = root.querySelector('form');
      const screens = [...root.querySelectorAll('.cp__screen[data-step]')];
      if (!screens.length) return;
      const bar = root.querySelector('[data-cp-bar]');
      const prevBtn = root.querySelector('.cp__nav [data-prev]');
      const nextBtn = root.querySelector('.cp__nav [data-next]');
      const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let i = 0;
      let busy = false;

      const field = (s) => s.querySelector('.cp__input');
      const picked = (s) => [...s.querySelectorAll('.cp__choice[aria-checked="true"]')].map((b) => b.dataset.choice);

      const valid = (s) => {
        const type = s.dataset.step;
        const required = s.hasAttribute('data-required');
        if (type === 'choice' || type === 'multi') return !required || picked(s).length > 0;
        const el = field(s);
        if (!el) return true;
        const v = el.value.trim();
        if (!v) return !required;
        if (type === 'email') return EMAIL.test(v);
        if (type === 'phone') return v.replace(/\D/g, '').length >= 7;
        return true;
      };

      const show = (n) => {
        screens.forEach((s, k) => {
          s.classList.toggle('is-active', k === n);
          s.classList.toggle('is-before', k < n);
          s.inert = k !== n;
        });
        i = n;
        bar.style.width = `${(n / (screens.length - 1)) * 100}%`;
        prevBtn.disabled = n === 0;
        nextBtn.disabled = n === screens.length - 1;
        const s = screens[n];
        const focusTarget = field(s) || (s.querySelector('.cp__choice') ? s : s.querySelector('.cp__btn'));
        setTimeout(() => focusTarget && focusTarget.focus({ preventScroll: true }), 350);
      };

      const next = () => {
        const s = screens[i];
        if (!valid(s)) {
          s.classList.add('has-error');
          return;
        }
        s.classList.remove('has-error');
        if (s.hasAttribute('data-last')) return submit();
        if (i < screens.length - 1) show(i + 1);
      };

      const prev = () => { if (i > 0) show(i - 1); };

      const submit = () => {
        if (busy) return;
        const bad = screens.findIndex((s) => !valid(s));
        if (bad !== -1) {
          show(bad);
          screens[bad].classList.add('has-error');
          return;
        }
        busy = true;
        root.querySelector('[data-submit]').disabled = true;
        form.submit();
      };

      root.querySelectorAll('[data-next]').forEach((b) => b.addEventListener('click', next));
      prevBtn.addEventListener('click', prev);
      form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });

      screens.forEach((s) => {
        const multi = s.dataset.step === 'multi';
        const hidden = s.querySelector('[data-value]');
        s.querySelectorAll('.cp__choice').forEach((b) => {
          b.addEventListener('click', () => {
            if (multi) {
              b.setAttribute('aria-checked', b.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
            } else {
              s.querySelectorAll('.cp__choice').forEach((o) => o.setAttribute('aria-checked', String(o === b)));
            }
            hidden.value = picked(s).join(', ');
            s.classList.remove('has-error');
            if (!multi) {
              b.classList.add('is-blink');
              setTimeout(() => { b.classList.remove('is-blink'); next(); }, 600);
            }
          });
        });
        const el = field(s);
        if (el) el.addEventListener('input', () => s.classList.remove('has-error'));
      });

      root.addEventListener('keydown', (e) => {
        const s = screens[i];
        if (e.key === 'Enter') {
          if (e.target.tagName === 'TEXTAREA' && !(e.metaKey || e.ctrlKey)) return;
          if (e.target.classList.contains('cp__choice') || e.target.tagName === 'BUTTON') return;
          e.preventDefault();
          next();
          return;
        }
        if (e.metaKey || e.ctrlKey || e.altKey) return;
        if (/^[a-z]$/i.test(e.key) && !field(s)) {
          const choice = s.querySelectorAll('.cp__choice')[e.key.toUpperCase().charCodeAt(0) - 65];
          if (choice) { e.preventDefault(); choice.click(); }
        }
      });

      show(0);
    };

    const boot = () => document.querySelectorAll('[data-cp]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
